<div class="container">
  <div [class.bg-gray]="type === 'gray'" [class.bg-gold]="type === 'gold'"></div>
</div>
